import React, { useState, useRef } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQs = () => {
    const faqs = [
        {
            question: "How can I manage my recipes in Cook-E?",
            answer:
                "In Cook-E, you can manage your recipes through the Cookbook Management feature. This allows you to change the list position of dishes, and reorganize based on preference. You can also edit, delete, and add new recipes.",
        },
        {
            question: "What is the Interactive Recipe Experience in Cook-E?",
            answer:
                "The Interactive Recipe Experience in Cook-E includes a speech function enabling users to listen to dishes and recipe sections. This feature is available in mid and top tier memberships and allows users to select from several voices via settings.",
        },
        {
            question: "Can I share recipes with friends on Cook-E?",
            answer:
                "Yes, Cook-E has a Social & Sharing feature. You can share recipes directly with friends, view recipes shared with you, and log your shared recipes. There's also a 'Share with another user' feature for direct recipe sharing using Cook-E usernames.",
        },
        {
            question: "What is the 'Ask a Question' feature in Cook-E?",
            answer:
                "The 'Ask a Question' feature in Cook-E provides context-aware answers to your queries about specific dishes, their process, ingredients, or utensils. This feature is available on the dish’s saved details page/pop-up for Tier 2 and 3 members.",
        },
        {
            question: "How does the Recipe Free Trial work in Cook-E?",
            answer:
                "New users in Cook-E get 5 recipe credits for free upon signing up. These credits can be used before any subscription message appears. If you upgrade your account before using all 5 recipes, the remaining credits roll into your subscription.",
        },
        {
            question: "How can I cancel my Cook-E subscription?",
            answer:
                "You can cancel your Cook-E subscription at any time. To do so, navigate to the Account Management page and select the 'Cancel Subscription' option. You will be asked to confirm your cancellation before it is processed.",
        },
        {
            question: "How can I change my Cook-E subscription?",
            answer:
                "You can change your Cook-E subscription at any time. To do so, navigate to the Account Management page and select the 'Change Subscription' option. You will be asked to confirm your subscription change before it is processed.",
        },
        {
            question: "What can I ask my Recipe Assistant?",
            answer:
                "Chat AI in Cook-E is available for all users. You can interact with Chat AI by asking questions like what drinks would pair well with this dish? what can I substitute the pickles for? or How do I roll the sushi together? and much more!",
        },
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const contentRef = useRef([]);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="w-full md:mx-auto md:py-12 px-4">

            {/* FAQ List */}
            <div className="bg-white bg-opacity-50 shadow-lg rounded-2xl p-6">
                {/* Title */}
                <div className="text-center mb-8">
                    <h1 className="text-3xl md:text-5xl font-extrabold text-[#A67FAA]" style={{ fontFamily: 'Raleway, sans-serif' }}>
                        FAQs
                    </h1>
                </div>
                {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-gray-300 py-4">
                        <button
                            className="flex justify-between font-publicSans items-center w-full text-left text-2xl font-semibold text-[#A67FAA]"
                            onClick={() => toggleFAQ(index)}
                        >
                            <span className='font-publicSans font-semibold pr-8 md:pr-0'>{faq.question}</span>
                            {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                        </button>

                        {/* Answer with smooth animation */}
                        <div
                            ref={(el) => (contentRef.current[index] = el)}
                            className="overflow-hidden transition-all duration-500 ease-in-out"
                            style={{
                                maxHeight: openIndex === index ? contentRef.current[index]?.scrollHeight : 0,
                                opacity: openIndex === index ? 1 : 0,
                            }}
                        >
                            <p className="mt-3 font-publicSans text-[#A67FAA] text-lg">
                                {faq.answer}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQs;
